import { render, staticRenderFns } from "./ModalAssociatedCasesReadOnly.vue?vue&type=template&id=f6abb268&scoped=true&"
import script from "./ModalAssociatedCasesReadOnly.vue?vue&type=script&lang=js&"
export * from "./ModalAssociatedCasesReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssociatedCasesReadOnly.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalAssociatedCasesReadOnly.vue?vue&type=style&index=1&id=f6abb268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6abb268",
  null
  
)

export default component.exports